import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {apiGetProfile} from '../../../apis/user/getUserProfile'
import {useString} from '../../../utils/string'

const useQueryGetUserProfile = (id: string, enabled: boolean = true) => {
    const {isNotEmpty} = useString()

    return useQuery({
        queryKey: QueryCacheKeys.user.getUserProfile(id),
        queryFn: async () => {
            const {data} = await apiGetProfile(id)
            return data
        },
        refetchOnWindowFocus: false,
        enabled: enabled ? enabled : isNotEmpty(id),
    })
}

export default useQueryGetUserProfile
